import React from "react";
import { Card, Button, Breadcrumb, Col, Divider, Row, Typography } from "antd";
import { Link } from "react-router-dom";
import PalapaLanding from "./palapalanding";

const style = {
  //background: "#0092ff",
  padding: "32px",
};

const gridStyle = {
  width: "300px",
  textAlign: "center",
};
const App = () => (
  <Card
    title={
      <Breadcrumb
        items={[
          {
            title: "Beranda",
          },
          { title: <Link to="/tools">Tools</Link> },
          {
            title: "Palapa",
          },
        ]}
      />
    }
    styles={{
      body: {
        maxHeight: "500px",

        overflow: "auto",
      },
    }}
  >
    <PalapaLanding />
  </Card>
);
export default App;
